import api from "./api";
import { toast } from "sonner";

export async function startCheckout(plan, interval = "monthly") {
  try {
    const { data } = await api.post("/billing/checkout", {
      plan, interval, origin_url: window.location.origin,
    });
    window.location.href = data.url;
  } catch (err) {
    toast.error(err?.response?.data?.detail || "Impossibile avviare il pagamento. Riprova.");
    throw err;
  }
}

export async function openPortal() {
  try {
    const { data } = await api.post("/billing/portal", { origin_url: window.location.origin });
    window.location.href = data.url;
  } catch (err) {
    toast.error(err?.response?.data?.detail || "Impossibile aprire la gestione abbonamento. Riprova.");
    throw err;
  }
}
